import type { FC } from 'react';
import { useIsEntitySuspended } from '../../hooks/useIsEntitySuspended';
import type { BlockComponentProps } from '../BlockRenderer/types';
import useGetFallbackNode from '../DataSourceController/hooks/useGetFallbackComponent';

function withSuspense<T, P, R>(Component: FC<BlockComponentProps<T, P, R>>) {
  return function SuspenseWrapper(props: BlockComponentProps<T, P, R>) {
    const { fallback, dataSourceIds, getGlobalStoreContext } = props;
    const context = getGlobalStoreContext();

    const { isSuspended } = useIsEntitySuspended({
      dataSourceIds,
      context,
    });

    const { fallbackNode } = useGetFallbackNode({
      fallback,
      isSuspended,
    });

    if (isSuspended) return fallbackNode;

    return <Component {...props} />;
  };
}

export default withSuspense;
